import renderFields from "../forms/forms-renderfields";

$().ready(function () {

  $(".navigate-back").click(function () {
    history.back()
  });

  function bindClickEventForPopupModal(event) {
    event.preventDefault();
    var src = $(this).attr("href");
    if ($("#iframe-modal").find("iframe").attr("src") != src) {
      $("#iframe-modal").find("iframe").attr("src", src);
    }
    $("#iframe-modal").show();
    $("#iframe-modal").fadeTo(1000, 1);
  };

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  var vfwcCentreCodeCookie = getCookie("vfwc-centre-code-cookie");
  var vfwcCentreTypeCookie = getCookie("vfwc-centre-type-cookie");

  var isQLDCentre = vfwcCentreTypeCookie == "true";
  if (!isQLDCentre) {
    $(".show-if-not-rslqld").show();
    $(".show-if-rslqld").hide();
  }
  $(".vfwc-page form a[href!=''][href], a.modal-iframe[href!=''][href]").on('click', bindClickEventForPopupModal);

  MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  var observer = new MutationObserver(function(mutations, observer) {
    if (!isQLDCentre) {
      $(".show-if-not-rslqld").show();
      $(".show-if-rslqld").hide();
    }

    $(".vfwc-page form a[href!=''][href], a.modal-iframe[href!=''][href]").off('click', bindClickEventForPopupModal);
    $(".vfwc-page form a[href!=''][href], a.modal-iframe[href!=''][href]").on('click', bindClickEventForPopupModal);
  });
  
  // define what element should be observed by the observer
  // and what types of mutations trigger the callback
  observer.observe(document, {
    subtree: true,
    attributes: true
    //...
  });

  $("#iframe-modal").click(function (event) {
    $("#iframe-modal").fadeOut(1000, function () {
      $("#iframe-modal").hide();
    });
  });

  $("#iframe-modal iframe").click(function (event) {
    event.stopPropagation();
  });

  
  var showInactiveModal = false;


  //Adding an audio element as an Base64 Attachment
  if (document.querySelector("#audio_element") != null) {
    document.querySelector("audio").play();
  }

  //TODO - create popup warning message if redirect is about to happen withing the next x seconds.
  if (window.vfwc && window.vfwc.redirectTimer > 0 ) {
    var idleTime = 0;
    var redirectTimer = window.vfwc.redirectTimer;
    var redirectLocation = window.vfwc.redirectLocation;
    var waitForInactivity = window.vfwc.waitForInactivity;
    var inactivityWarningTime = window.vfwc.inactivityWarningTime;
    $("#inacive-modal .inactive-heading").html(window.vfwc.inactivityWarningHeading);

    function vfwcTimerIncrement() {
      idleTime = idleTime + 1;
      if (idleTime > redirectTimer) {
        window.location.href = redirectLocation;
        idleTime = 0;
      }
      var timeTillRedirect = redirectTimer - idleTime;
      $("#inacive-modal .inactive-text").html("Returning home in " + timeTillRedirect);
      if (showInactiveModal == false && inactivityWarningTime > 0 && waitForInactivity && idleTime > (redirectTimer - inactivityWarningTime)) {
        showInactiveModal = true; 
        $("#inacive-modal").show();
        $("#inacive-modal").fadeTo(1000, 1);
      }
    }

    function resetIdleTime(event) {
      idleTime = 0;
      if (showInactiveModal) {
        showInactiveModal = false;
        $("#inacive-modal").fadeOut(1000, function () {
          $("#inacive-modal").hide();
        });
      }
    }

    // Increment the idle time counter every second.
    var idleInterval = setInterval(vfwcTimerIncrement, 1000); // 1 second

    if (waitForInactivity) {
      // Zero the idle timer on mouse movement.
      $(document).mousemove(resetIdleTime);
      $(document).mousedown(resetIdleTime);
      $(document).mouseup(resetIdleTime);
      $(document).keyup(resetIdleTime);
      $(document).scroll(resetIdleTime);
      $(document).resize(resetIdleTime);
    }
  }

  if ($('#dependantListVfwc').length==0) {
    /* if dependant doesnt exists */
    $(".checkDependantListVfwc").prop('disabled', true);
    $(".checkDependantListVfwc").addClass("btn-disabled");
  }

  renderFields.Date();

  var isGoBackOpen = true;
  var goBacKBtnText = '';
  var vfwcGoBacktogglebtn = function () {
    if (isGoBackOpen) {
      $('.vfwc-go-back-togglebtn').addClass('vfwc-go-back-close')
      $('.vfwc-go-back-togglebtn').removeClass('vfwc-go-back-open')
      $('.vfwc-go-back-togglebtn-text').html("<<")
    } else {
      $('.vfwc-go-back-togglebtn').removeClass('vfwc-go-back-close')
      $('.vfwc-go-back-togglebtn').addClass('vfwc-go-back-open')
      $('.vfwc-go-back-togglebtn-text').html("<a class='vfwc-go-back-togglebtn-a' href='" + (window.vfwc && window.vfwc.redirectLocation ? window.vfwc.redirectLocation : "/vfwc") + "'>" + goBacKBtnText + "</a>")
    }
  }
  var goBackBtnVfwc = $('button.vfwc-go-back-btn');

  if (goBackBtnVfwc && goBackBtnVfwc.length == 1) {
    goBacKBtnText = $('button.vfwc-go-back-btn').text()
    goBackBtnVfwc.click(function () {
      window.location.href = window.vfwc && window.vfwc.redirectLocation ? window.vfwc.redirectLocation : "/vfwc"
    })
    goBackBtnVfwc.after('<div class="fa fa-angle-up vfwc-go-back-togglebtn"><div class="vfwc-go-back-togglebtn-text"><<</div></div>')
    $('.vfwc-go-back-togglebtn').on('click', function () {

      if (isGoBackOpen) {
        isGoBackOpen = false;
        vfwcGoBacktogglebtn();
      }
    });
    $(window).click(function (e) {
      if ($(e.target).hasClass('vfwc-go-back-togglebtn') || $(e.target).hasClass('vfwc-go-back-togglebtn-text') || $(e.target).hasClass('vfwc-go-back-togglebtn-a')) {
        return;
      }
      if (!isGoBackOpen) {
        isGoBackOpen = true;
        vfwcGoBacktogglebtn();
      }
    });
  }
});
